import { withSiteMap } from '../util/with-site-map';

const backendLink = withSiteMap('https://{SITE_MAP}78.ru/api', process.env.SITEMAP);
const staticLink = withSiteMap('https://78.ru/images/uploads', process.env.SITEMAP);
const nodeEnv = process.env.NODE_ENV;
const backendUrl = nodeEnv === 'development' ? 'https://staging.78.ru/api' : 'https://78.ru/api';
// const backendUrl = 'http://localhost:5000';

const staticUrl = nodeEnv === 'development' ? 'http://localhost:5000/upload' : staticLink;
export const streamStates = [
	{
		value: 'on_air',
		primaryText: 'В эфире',
	},
	{
		value: 'published',
		primaryText: 'Опубликован',
	},
	{
		value: 'draft',
		primaryText: 'Черновик',
	},
	{
		value: 'deleted',
		primaryText: 'Удалён',
	},
	{
		value: 'finished',
		primaryText: 'Завершён',
	},
];

const sectionPath = {
	news: 'U2VjdGlvbjo1OTg4YmM3MTNhODdiYzUyMDMwMzUyMzQ=',
	article: 'U2VjdGlvbjo1OTg4YmNiNzA2YmFlMjUyNzU3NmJhMWI=',
	rubricTv: 'U2VjdGlvbjo1OWNjZGFhZTU0OWZlOWI1OTNkYzQwZWQ=',
};

export { backendUrl, staticUrl, sectionPath };



// WEBPACK FOOTER //
// src/lib/config.js